import { createContent } from '@altify/utils';

export const content = createContent({
    en: {
        secureTradePriceWithin: 'Secure trade price within',
        quoteExpired(assetCode: string) {
            return `Your quote for ${assetCode} has expired`;
        },
        confirmDetails: 'Confirm Details',
        confirmBuy: 'Confirm Buy',
        refreshQuote: 'Refresh Quote',
        confirmSale: 'Confirm Sale',
        tradePrice: 'Trade Price',
        tradingFee: 'Trading Fee',
        smartTrade: 'Smart Trade',
        youAreUsing: "You're Using",
        youAreBuying: "You're Buying",
        youAreReceiving: "You're Receiving",
        orderType: 'Order Type',
        tradeError:
            'Your trade cannot be completed.\n\nPlease try again in a few minutes.',
    },
    de: {
        secureTradePriceWithin: 'Sichere den Handelspreis innerhalb von',
        quoteExpired(assetCode: string) {
            return `Dein Preisangebot für ${assetCode} ist abgelaufen`;
        },
        confirmDetails: 'Details bestätigen',
        confirmBuy: 'Kauf bestätigen',
        refreshQuote: 'Angebot aktualisieren',
        confirmSale: 'Verkauf bestätigen',
        tradePrice: 'Preis',
        tradingFee: 'Trading-Gebühren',
        smartTrade: 'Smart Trade',
        youAreUsing: 'Du benutzt',
        youAreBuying: 'Du kaufst',
        youAreReceiving: 'Du erhältst',
        orderType: 'Order Typ',
        tradeError: 'Dein Trade kann zurzeit nicht ausgeführt werden',
    },
});